import BookmarkSharpIcon from '@mui/icons-material/BookmarkSharp';

export default BookmarkSharpIcon;
